export const GET_ALL_PRODUCTS = 'GET_ALL_PRODUCTS';
export const GET_ALL_PRODUCTS_SUCCESS = 'GET_ALL_PRODUCTS_SUCCESS';
export const GET_ALL_PRODUCTS_FAIL = 'GET_ALL_PRODUCTS_FAIL';
export const UPDATE_PRODUCT_VARIATIONS_IN_ALL = 'UPDATE_PRODUCT_VARIATIONS_IN_ALL';